import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  private connectionMonitor$ = new BehaviorSubject<boolean>(true);

  constructor() {}

  setOnline() {
    this.connectionMonitor$.next(true);
  }

  setOffline() {
    this.connectionMonitor$.next(false);
  }

  monitor(): Observable<boolean> {
    return this.connectionMonitor$;
  }
}
